// ---BT-107433_SrikanthRao_9-10-2023_Calculator || Functional Implementation

import { useState, useCallback, useRef, useEffect } from 'react';
import { Row, Col, Container, Dropdown } from 'react-bootstrap';
import { BzInputText, BzButton, BzCard, BzDropdown } from '../../components';
import { InlineScripSeach } from '../Search';
import { useDispatch, useSelector } from 'react-redux';
import { resetSearchData } from '../../redux/actions/globalSearch';
import { _dateDiffernece, _handleTouchlineSubscription } from '../../controllers/calculator';
import { LAYOUT_TYPE, TL_INDEX, WATCHLIST_GRID_INDEX } from '../../utils/global_variables';
import { getScripbyTokenAndMktSegId } from '../../apis';
import { convertScripResponseWatchlistGrid, getApiExchangeNameFromMktSegId, getAssetExchangeName, getDynamicParamsForToFixed, getMappedMktSegIdFromApiExchangeName, getMktSegIdFromMappedMktSegId, ORDER_ENTRY_GRID_REF } from '../../utils/global_functions';//ManasaB : 22/11/2023 : BT-115296 Calculator Bug Fixing 
import { useWFHMessages } from '../../hooks';
import { _calcFairValue, _validateOptionValues } from '../../controllers/calculator/futurefairValueCalculation';
import { handleModal } from '../../redux/actions/modals';
import { getScripOrderInfo } from '../../redux/actions/orders';
import moment from 'moment';
import { getWfhTouchlineLastTick } from '../../redux/actions/wfh';

const FutureFairValue = ({ layoutType }) => {
    const dispatch = useDispatch();
    const [bToggleSearchBar, setBToggleSearchBar] = useState(true);
    const inputRef = useRef();
    const [objScripSearch, setobjScripSearch] = useState({});
    const [customDays, setCustomDays] = useState(0);
    const [bcustomDays, setbcustomDays] = useState(true);
    const [objSubscribedSegIdToken, setObjSubscribedSegIdToken] = useState({});
    const [fairValue, setFairValue] = useState(0);
    const arrExpiryDates = useSelector(state => state.optionChain.arrDistinctDates);//ManasaB : 30/11/2023 : BT-115296 Calculator Bug Fixing 
    const [arrExpiryDayOption, setArrExpiryDayOption] = useState([{ expireDate: "", nDayDiff: 0 }]);
    const [resultSpotPrice, setResultSpotPrice] = useState(0);
    const [decimalLocatorLength, setDecimalLocatorLength] = useState(2);





    const [selectCalculatorOption, setSelectCalculatorOption] = useState({
        expiryOrContractDays: { expireDate: "", nDayDiff: 0 },
        spotPrice: "", interestRate: "", dividend: "", dateDiffernece: 0,
        // customDays = 0
    });

    const [objWarnings, setObjWarning] = useState({
        contract: false,
        spotPrice: false,
        interestRate: false,
        dividend: false,

    });
    const regex = /^\d*\.?\d{0,2}$/;


    // const OptionPopOverName = useCallback(() => {
    //     if ((objScripSearch?.nExpiryDate1 && objScripSearch?.nStrikePrice1 &&
    //         objScripSearch?.sInstrumentName)) {
    //         return (<div className='font-regular font-size4 color-subtext me-2'>{`${objScripSearch?.nExpiryDate1?.slice(0, 2)}  ${objScripSearch?.nExpiryDate1?.slice(2, 5)} ${objScripSearch?.nStrikePrice1} ${objScripSearch?.sOptionType} `}</div>);
    //     } else if (!objScripSearch?.nExpiryDate1 && !objScripSearch?.nStrikePrice1 &&
    //         !objScripSearch?.sOptionType) {
    //         return (<div className='font-regular font-size4 color-subtext me-2'>{objScripSearch?.sSeries}</div>);
    //     }
    //     else if (objScripSearch?.nExpiryDate1 && !objScripSearch?.nStrikePrice1) {
    //         return (
    //             <div className='font-regular font-size4 color-subtext me-2'>{`${objScripSearch?.nExpiryDate1?.slice(0, 2)}  ${objScripSearch?.nExpiryDate1?.slice(2, 5)} ${objScripSearch?.sInstrumentName?.slice(0, 3)} `}</div>
    //         );
    //     } else {
    //         return null;
    //     }
    // }, [objScripSearch]);
    const OptionPopOverName = useCallback(() => {
        if ((objScripSearch.nExpiryDate1 && objScripSearch.nStrikePrice1 &&
            objScripSearch.sInstrumentName)) {
            return (<div className='font-regular font-size4 color-subtext me-2'>{`${objScripSearch.nExpiryDate1.slice(0, 2)}  ${objScripSearch.nExpiryDate1.slice(2, 5)} ${objScripSearch.nStrikePrice1} ${objScripSearch.sOptionType} `}</div>);
        } else if (!objScripSearch.nExpiryDate1 && !objScripSearch.nStrikePrice1 &&
            !objScripSearch.sOptionType) {
            return (<div className='font-regular font-size4 color-subtext me-2'>{objScripSearch.sSeries}</div>);
        }
        else if (objScripSearch.nExpiryDate1 && !objScripSearch.nStrikePrice1) {
            return (
                <div className='font-regular font-size4 color-subtext me-2'>{`${objScripSearch?.nExpiryDate1?.slice(0, 2)}  ${objScripSearch?.nExpiryDate1?.slice(2, 5)} ${objScripSearch?.sInstrumentName?.slice(0, 3)} `}</div>
            );
        } else {
            return null;
        }
    }, [objScripSearch]);

    const handleSearch = () => {
        setBToggleSearchBar(curr => !curr);
    };
    const handleSelectScripFromGlobalSearch = async (arrScrip) => {
        setSelectCalculatorOption(curr => ({ ...curr, spotPrice: 0 }));
        setFairValue(0);
        setResultSpotPrice(0);
        setObjWarning({
            contract: false,
            spotPrice: false,
            interestRate: false,
            dividend: false,

        });
        const arrSelectedScrip = await getScripbyTokenAndMktSegId([{ mkt: getApiExchangeNameFromMktSegId(getMktSegIdFromMappedMktSegId(arrScrip[WATCHLIST_GRID_INDEX?.MAPPED_SEGMENT_ID])), token: arrScrip[WATCHLIST_GRID_INDEX?.TOKEN], }]);
        const exchangeName = getApiExchangeNameFromMktSegId(getMktSegIdFromMappedMktSegId(arrScrip[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID]));
        const decimalLength = getDynamicParamsForToFixed(exchangeName);
        setDecimalLocatorLength(decimalLength);
        // setSelectCalculatorOption({ ...selectCalculatorOption, spotPrice: (0).toFixed(decimalLength) });
        setResultSpotPrice(0);
        if (arrSelectedScrip) {
            const objSelectedScrip = arrSelectedScrip?.data.result[0];
            if (objSelectedScrip) {
                // try-------------------
                const nGetAssetExchangeName = getAssetExchangeName(objSelectedScrip.MktSegId);
                const nAssetMktSegId = getMappedMktSegIdFromApiExchangeName(nGetAssetExchangeName);
                setobjScripSearch(objSelectedScrip);
                if (Object.keys(selectCalculatorOption.expiryOrContractDays).length > 0) {
                    let nDayDiff = _dateDiffernece(objSelectedScrip.nExpiryDate1);
                    // let objExpiryContract = { expireDate: objSelectedScrip.nExpiryDate1, nDayDiff: nDayDiff };
                    setSelectCalculatorOption(curr => ({ ...curr, expiryOrContractDays: { expireDate: moment(objSelectedScrip.nExpiryDate1).format("DD MMM 'YY"), nDayDiff: nDayDiff } })); //BT-107433 : Calculator : SAT2 Issues : ManasaB : 23-03-2024 
                    setCustomDays(nDayDiff);
                }
                //Azeem K : 08-04-2024 : BT-131598- Breeze - Calculators - Start
                const nAssetToken = objSelectedScrip.nAssetToken === 0 ? objSelectedScrip.nToken : objSelectedScrip.nAssetToken;
                //Azeem K : 08-04-2024 : BT-131598- Breeze - Calculators - End
                const arrLocSubscribedSegIdToken = { mkt: nAssetMktSegId, token: nAssetToken };
                setObjSubscribedSegIdToken({ mkt: nAssetMktSegId, token: nAssetToken });
                _handleTouchlineSubscription(arrLocSubscribedSegIdToken, true, "spot");

            } else {
                return false;
            }
        } else {
            return false;
        }

        dispatch(resetSearchData());
        setBToggleSearchBar(curr => !curr);
    };
    //Azeem K : 08-04-2024 : BT-131598- Breeze - Calculators - Start
    useEffect(() => {
        const objLastTickData = dispatch(getWfhTouchlineLastTick());
        const nGetAssetExchangeName = getAssetExchangeName(objScripSearch.MktSegId);
        const nAssetMktSegId = getMappedMktSegIdFromApiExchangeName(nGetAssetExchangeName);
        const nAssetToken = objScripSearch.nAssetToken === 0 ? objScripSearch.nToken : objScripSearch.nAssetToken;

        const arrLastTick = objLastTickData[nAssetMktSegId + '_' + nAssetToken];

        if (arrLastTick?.length > 0) {
            handleOnSelectCalculatorOptionChange({ target: { name: 'spotPrice', value: arrLastTick[TL_INDEX.LAST_TRADE_PRICE] } });
        }

    }, [objScripSearch]);
    //Azeem K : 08-04-2024 : BT-131598- Breeze - Calculators - End




    const handleCalculate = async () => {
        let DaysDiff = bcustomDays ? selectCalculatorOption?.expiryOrContractDays?.nDayDiff : customDays;
        let validation = await _validateOptionValues(selectCalculatorOption, DaysDiff);//ManasaB : 26-03-2024 : Changed after discussion with Srikanth for contract validation
        setObjWarning(validation);
        if (!validation?.contract && !validation?.spotPrice && !validation?.interestRate && !validation?.dividend && Object.keys(objScripSearch).length > 0) {
            let nfairValue = await _calcFairValue(selectCalculatorOption.spotPrice, selectCalculatorOption.interestRate, selectCalculatorOption.dividend, DaysDiff);
            setFairValue(nfairValue);
            setResultSpotPrice(Number(selectCalculatorOption?.spotPrice).toFixed(decimalLocatorLength));
        } else {
            return false;
        }


    };

    const handleCalculatorInputs = useCallback((e) => {
        const { name, value } = e.target;
        if (regex.test(value)) {
            setSelectCalculatorOption(curr => ({ ...curr, [name]: value }));
        }
    }, []);


    useEffect(() => {
        //BT-107433 : Calculator : SAT2 Issues : ManasaB : 23-03-2024 - Start
        if (Object.keys(objScripSearch).length > 0) {//ManasaB : 04/12/2023 : Resolved Bug on reset 
            let objMatchingExpiryDate = arrExpiryDayOption?.find(eachDate => eachDate?.expireDate === moment(objScripSearch?.nExpiryDate1).format("DD MMM 'YY"));
            if (objMatchingExpiryDate) {
                setSelectCalculatorOption({ ...selectCalculatorOption, expiryOrContractDays: objMatchingExpiryDate });
                setCustomDays(objMatchingExpiryDate?.nDayDiff);
            }
            else {
                let objMatchingExpiryDate = arrExpiryDayOption[0];
                setSelectCalculatorOption(curr => ({ ...curr, expiryOrContractDays: objMatchingExpiryDate }));
                setCustomDays(objMatchingExpiryDate?.nDayDiff);
            }
            //BT-107433 : Calculator : SAT2 Issues : ManasaB : 23-03-2024 - End
        }
        //ManasaB : 22/11/2023 : BT-115296 Calculator Bug Fixing - End
    }, [arrExpiryDayOption, objScripSearch]);


    useEffect(() => {
        //ManasaB : 30/11/2023 : BT-115296 Calculator Bug Fixing - Start
        if (arrExpiryDates?.length > 0 && Object.keys(objScripSearch).length > 0) { //ManasaB : 04/12/2023 : Resolved Bug in expiry day drop down after reset
            let arrFilteredExpiryDates = arrExpiryDates.filter(eachDate => eachDate.strDate !== '');
            const filterDulicateDate = (arrDates) => {
                let arrUniqueDates = new Set();
                return arrDates.filter(eachObj => {

                    if (!arrUniqueDates.has(eachObj.strDate)) {
                        arrUniqueDates.add(eachObj.strDate);
                        return true;
                    }
                    return false;

                });
            };
            const arrFinalFilterExpDates = filterDulicateDate(arrFilteredExpiryDates);
            //Azeem K : 08-04-2024 : BT-131598- Breeze - Calculators - Start
            if (arrFinalFilterExpDates?.length < 1) {
                setbcustomDays(false);
            } else {
                setbcustomDays(true);
            }
            //Azeem K : 08-04-2024 : BT-131598- Breeze - Calculators - End

            setArrExpiryDayOption((arrFinalFilterExpDates).map((e) => {
                let nDayDiff = _dateDiffernece(e.strDate);
                return { expireDate: moment(e.strDate).format("DD MMM 'YY"), nDayDiff: nDayDiff };

            }));
        }

        // const getExpireDataInRedux = async () => {
        // const objResp = await _getExpireDataInRedux(objScripSearch);
        //     if (objResp?.status) {
        //         setArrExpiryDayOption(Object.keys(objResp.data).map((e) => {
        //             let nDayDiff = _dateDiffernece(e);
        //             return { expireDate: e, nDayDiff: nDayDiff };

        //         }));

        //     } else {
        //         console.log(objResp?.status);
        //     }

        // };

        // getExpireDataInRedux();
        //ManasaB : 30/11/2023 : BT-115296 Calculator Bug Fixing - End
    }, [objScripSearch]);

    // const handleLtpUnsubscription = (scrip, unsubscribe) => {
    //     const arrScripsForUnSubscription = [{ exchangeId: scrip.mkt, token: scrip.token, isSubscribe: unsubscribe }];
    //     sendTouchlineRequest(arrScripsForUnSubscription);

    // };
    const handleTouchLineData = useCallback((arrTouchlineData) => {
        if (selectCalculatorOption?.spotPrice === "" && Object.keys(objScripSearch).length > 0) { ////ManasaB : 22/11/2023 : BT-115296 Calculator Bug Fixing 

            if (objSubscribedSegIdToken.mkt + '_' + objSubscribedSegIdToken.token === arrTouchlineData[TL_INDEX?.SEGMENT_ID] + '_' + arrTouchlineData[TL_INDEX?.TOKEN]) {
                setSelectCalculatorOption(curr => ({ ...curr, spotPrice: arrTouchlineData[TL_INDEX?.LAST_TRADE_PRICE] }));
                _handleTouchlineSubscription(objSubscribedSegIdToken, false, "spot");

            } else {
                return false;
            }
        } else {
            return false;
        }

    }, [objScripSearch, selectCalculatorOption]);



    const handleOnSelectCalculatorOptionChange = useCallback((e) => {
        const { name, value } = e.target;
        if (name === "expiryOrContractDays") {
            if (e.target.value === "customDays") {
                setbcustomDays(false);
            } else {
                setbcustomDays(true);
                let objValue = JSON.parse(e.target.value);
                setSelectCalculatorOption(curr => ({ ...curr, [name]: { expireDate: objValue.date, nDayDiff: objValue.days } }));
                setCustomDays(objValue.days);
            }

        } else if (name === "dividend" || name === "interestRate") {
            if ((value < 0)
                //  || (value > 99.99)
            ) {
                return false;
            } else {
                if (regex.test(value)) {
                    setSelectCalculatorOption(curr => ({ ...curr, [name]: value }));
                }
            }

        }
        else {
            if (regex.test(value)) {
                setSelectCalculatorOption(curr => ({ ...curr, [name]: value }));
            }
        }
    }, []);
    // const date = useMemo(() => {
    //     if (!initial) {
    //         return selectCalculatorOption?.expiryOrContractDays?.expireDate;
    //     } else {

    //         return JSON.stringify({ date: selectCalculatorOption?.expiryOrContractDays?.expireDate, days: selectCalculatorOption?.expiryOrContractDays?.nDayDiff });
    //     }
    // }, [selectCalculatorOption?.expiryOrContractDays?.expireDate]);

    const handleReset = () => {
        setobjScripSearch({});
        setBToggleSearchBar(false);
        setArrExpiryDayOption([{ expireDate: "", nDayDiff: 0 }]);
        setSelectCalculatorOption({
            expiryOrContractDays: { expireDate: "", nDayDiff: 0 },
            spotPrice: "", interestRate: "", dividend: "", dateDiffernece: 0
        });

        setObjWarning({
            contract: false,
            spotPrice: false,
            interestRate: false,
            dividend: false,

        });
        setFairValue(0);
        setResultSpotPrice(0);
        setBToggleSearchBar(true);
        setCustomDays(0);//ManasaB : 04/12/2023 : Resolved Bug on reset 
        setbcustomDays(true);

    };

    useWFHMessages('touchline', (e) => {
        handleTouchLineData(e.detail);
    });


    const handlePlaceOrder = async (nIsBuyOrSell = 0) => {
        if (Object.keys(objScripSearch).length) {
            const arrconvertedScrips = await convertScripResponseWatchlistGrid([objScripSearch]);
            ORDER_ENTRY_GRID_REF.current.setIsScripPrice(false);//ManasaB : 22/11/2023 : BT-115296 Calculator Bug Fixing 
            dispatch(getScripOrderInfo({ isBuySell: nIsBuyOrSell, activeExchangeId: arrconvertedScrips[0][WATCHLIST_GRID_INDEX.SEGMENT_ID], scripData: arrconvertedScrips[0] }));

            dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': true }]));
        } else {
            return false;
        }
    };

    const onBuySellClick = (strBuySell) => {

        handlePlaceOrder(strBuySell === 'BUY' ? 0 : 1);
    };

    useEffect(() => {
        if (Object.keys(objScripSearch).length > 0) {

            const clickFunction = (event) => {
                if (bToggleSearchBar && (!inputRef?.current?.contains(event.target) && !event.target.matches('.inline-search-scrip-list, .inline-search-scrip-list *'))) {
                    setBToggleSearchBar(false);
                }
            };
            document.addEventListener('mousedown', clickFunction);
            return () => {
                document.removeEventListener('mousedown', clickFunction);
            };
        } else {

        }
    }, [bToggleSearchBar, objScripSearch]);

    return (
        <>
            {
                layoutType === LAYOUT_TYPE.HORIZONTAL ?
                    <>
                        <div className='calculators-wrapper'>  
                            <Container fluid className='p-lg-0'>
                                <Row className='g-xl-0 py-3'>
                                    <Col xl={9} className='mrgauto'>
                                        <Container fluid className='p-0'>
                                            <Row className='g-0'>
                                                <Col xl={8} className='d-flex justify-content-start'>
                                                    <Container fluid className='p-0 calculators-cards-wrapper me-xl-3 mb-3'>                                                        
                                                            <div className='calculators-cards-header'>
                                                                <Row className='g-0 align-items-center'>
                                                                    <Col className='d-flex justify-content-start align-items-center'>
                                                                        <div className='font-regular font-size6 color-text'>Future Fair Value Calculator</div>
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                            <div className='calculators-cards-container p-3'>
                                                                <Row className='g-0 site-calc-search'>
                                                                    <Col className='mb-3'>
                                                                        {
                                                                            bToggleSearchBar ? (
                                                                                <div className='w-100 mt-4 calculator-form-control'> {/* Bhagyashri P [12-12-2023] : BT-107433 Calculators Integration - class changes */}
                                                                                    <InlineScripSeach className='site-calc-search' ref={inputRef} handleSelectScripFromGlobalSearch={handleSelectScripFromGlobalSearch} setBToggleSearchBar={setBToggleSearchBar} bFut={true} bSelectedCalculatorScrip={(Object.keys(objScripSearch).length > 0) ? true : false} bIsFutureFair={true} />{/*}ManasaB : 22/11/2023 : BT-115296 Calculator Bug Fixing : Added bIsFutureFair*/}
                                                                                </div>
                                                                            )
                                                                                :
                                                                                <>
                                                                                    <div className='d-flex align-items-center mb-1'>
                                                                                        <div className='font-medium font-size4 color-text text-uppercase me-2'>{objScripSearch?.sSymbol}</div>
                                                                                        {(Object.keys(objScripSearch).length) ?
                                                                                            <OptionPopOverName />
                                                                                            : null
                                                                                        }
                                                                                        <div className='icon-16 icon-search icon-dark' onClick={handleSearch}></div>
                                                                                    </div>
                                                                                    <div>
                                                                                        <div className='chips-wrap'>
                                                                                            <div className='exchange-chip me-2'>{objScripSearch.sExchange}</div>
                                                                                        </div>
                                                                                    </div>
                                                                                </>

                                                                        }
                                                                    </Col>
                                                                    <Col md={1} className='d-none d-xl-block'>&nbsp;</Col>
                                                                    <Col className='d-none d-xl-block'>&nbsp;</Col>
                                                                </Row>
                                                                {/* ManasaB : 30/11/2023 : BT-115296 Calculator Bug Fixing - Start */}
                                                                {/* <Row className='g-0 mb-3'>
                                                                    <Col>
                                                                        {(Object.keys(objScripSearch).length) ? <div className='chips-wrap'>
                                                                            <div className='font-regular font-size4 color-subtext me-2 exchange-chip'>{objScripSearch.sExchange}</div>
                                                                        </div> : null}
                                                                    </Col>
                                                                </Row> */}
                                                                {/* ManasaB : 30/11/2023 : BT-115296 Calculator Bug Fixing - End */}
                                                                <Row className='g-0 mb-3'>
                                                                    <Col className='d-flex flex-column justify-content-start align-items-start'>
                                                                        <div className='font-regular font-size3 color-subtext mb-1'>Spot Price</div>
                                                                        <div className='input-group'>
                                                                            <BzInputText onKeyDown={(e) => (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') && e.preventDefault()} type="number" size="sm" min="0" max="99.99" name='spotPrice' value={selectCalculatorOption?.spotPrice} className='font-regular form-control' onChange={handleOnSelectCalculatorOptionChange} placeholder='Enter Value' />   {/* Bhagyashri P [07-12-2023] : BT-107433 Calculators Integration - class changes */}
                                                                        </div>
                                                                        {objWarnings?.spotPrice ? <span className='font-regular font-size1 color-error ms-1'>Spot Price is Not Valid</span> : null}
                                                                    </Col>
                                                                    <Col md={1}>&nbsp;</Col>
                                                                    <Col className='d-flex justify-content-start align-items-start'>
                                                                        <Container fluid className='p-0'>
                                                                            <Row className='g-0'>
                                                                                <Col className='d-flex flex-column justify-content-start align-items-start'>
                                                                                    <div className='font-regular font-size3 color-subtext mb-1'>Expiry</div>
                                                                                    <div className='Bzmodalselect-dropdown w-100'>
                                                                                        <BzDropdown>
                                                                                            <Dropdown.Toggle disabled={Object.keys(objScripSearch).length === 0} className='btn-default'>{selectCalculatorOption?.expiryOrContractDays?.expireDate ? selectCalculatorOption?.expiryOrContractDays?.expireDate : 'Enter Value'}</Dropdown.Toggle>
                                                                                            <Dropdown.Menu>
                                                                                                {arrExpiryDayOption?.length > 0 && arrExpiryDayOption?.map((eachOption, i) => (
                                                                                                    <Dropdown.Item key={i} onClick={() => handleOnSelectCalculatorOptionChange({ target: { value: JSON.stringify({ date: eachOption?.expireDate, days: eachOption?.nDayDiff }), name: 'expiryOrContractDays' } })}>{`${eachOption?.expireDate}  `}</Dropdown.Item>
                                                                                                ))}
                                                                                                <Dropdown.Item onClick={() => handleOnSelectCalculatorOptionChange({ target: { value: 'customDays', name: 'expiryOrContractDays' } })}>Custom Day's</Dropdown.Item>
                                                                                            </Dropdown.Menu>
                                                                                        </BzDropdown>
                                                                                    </div>
                                                                                </Col>
                                                                                <Col md={1}>&nbsp;</Col>
                                                                                <Col className='d-flex flex-column justify-content-start align-items-start'>
                                                                                    <div className='font-regular font-size3 color-subtext mb-1'>Contract Days</div>
                                                                                    <div className={`input-group postion-relative ${bcustomDays ? 'disabled pointer-events-none' : ''}`}>
                                                                                        <div className={`icon-12 icon-order-decrease input-number-left-wrap ${bcustomDays && 'div-disabled'}`} name='capPrice' onClick={() => { setCustomDays(customDays > 0 ? customDays - 1 : false); }}></div>
                                                                                        <BzInputText onKeyDown={(e) => (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') && e.preventDefault()} type='number' size="sm" name='customDays' disabled={bcustomDays} value={customDays} className='text-center p-0 font-regular' min={0} onChange={(e) => setCustomDays(e.target.value)} />   {/* Bhagyashri P [07-12-2023] : BT-107433 Calculators Integration - class changes  ManasaB : 20/03/2024 SAT -2nd cycle bug fixing*/}
                                                                                        <div className={`icon-12 icon-order-increase input-number-right-wrap ${bcustomDays && 'div-disabled'}`} name='capPrice' onClick={() => { setCustomDays(customDays + 1); }}></div>   {/* Bhagyashri P [07-12-2023] : BT-107433 Calculators Integration - class changes */}
                                                                                    </div>
                                                                                    {objWarnings?.contract ? <span className='font-regular font-size1 color-error ms-1'>Contract Days is Not Valid</span> : null}
                                                                                </Col>
                                                                            </Row>
                                                                        </Container>
                                                                    </Col>
                                                                </Row>
                                                                <Row className='g-0 mb-3'>
                                                                    <Col className='d-flex flex-column justify-content-start align-items-start'>
                                                                        <div className='font-regular font-size3 color-subtext mb-1'>Interest rate [%]</div>
                                                                        <div className='input-group'>
                                                                            <BzInputText onKeyDown={(e) => (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') && e.preventDefault()} type="number" size="sm" min="0" max="99.99" name='interestRate' value={selectCalculatorOption?.interestRate} className='font-regular form-control' placeholder="Enter Value" onChange={handleOnSelectCalculatorOptionChange} />   {/* Bhagyashri P [12-12-2023] : BT-107433 Calculators Integration - class changes */}
                                                                        </div>
                                                                        <div className='d-flex align-items-center mt-2'>
                                                                            <div className='icon-16 icon-info icon-grey ms-1 me-2'></div>
                                                                            <div className='font-regular font-size1 color-subtext'>Range: 0.01 - 99.99%</div>
                                                                        </div>
                                                                        {objWarnings?.interestRate ? <span className='font-regular font-size1 color-error ms-1'>Please enter Interest Rate between 0.01 and 99.99</span> : null}
                                                                    </Col>
                                                                    <Col md={1}>&nbsp;</Col>
                                                                    <Col className='d-flex flex-column justify-content-start align-items-start'>
                                                                        <div className='font-regular font-size3 color-subtext mb-1'>Dividend</div>
                                                                        <div className='input-group'>
                                                                            <BzInputText onKeyDown={(e) => (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') && e.preventDefault()} type="number" size="sm" min="0" max="99.99" name='dividend' value={selectCalculatorOption?.dividend} className='font-regular form-control' onChange={handleOnSelectCalculatorOptionChange} placeholder='Enter Value' />   {/* Bhagyashri P [07-12-2023] : BT-107433 Calculators Integration - class changes */}
                                                                        </div>
                                                                        <div className='d-flex align-items-center mt-2'>
                                                                            <div className='icon-16 icon-info icon-grey ms-1 me-2'></div>
                                                                            <div className='font-regular font-size1 color-subtext'>Range: 0 - 99.99%</div>
                                                                        </div>
                                                                        {objWarnings?.dividend ? <span className='font-regular font-size1 color-error ms-1'>Please enter Dividend between 0 and 99.99</span> : null}
                                                                    </Col>
                                                                </Row>                                                                                                                               
                                                            </div>                                                        
                                                    </Container>
                                                </Col>
                                                <Col md={4} className='d-flex justify-content-end col-sm-12'>
                                                    <Container fluid className='p-0 calculators-cards-wrapper me-xl-3 mb-3'>                                                        
                                                            <div className='calculators-cards-header'>
                                                                <Row className='g-0 align-items-center'>
                                                                    <Col className='d-flex justify-content-start align-items-center'>
                                                                        <div className='font-regular font-size6 color-text'>Results</div>  
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                            <div className='calculators-cards-container p-3'>
                                                                {fairValue > 0 &&
                                                                    <>
                                                                        <Row className='g-0 bdr-btm px-2 py-3'>
                                                                            <Col className='d-flex justify-content-start align-items-center'>
                                                                                <div className='font-medium font-size5 color-text me-2'>Fair Value:</div>
                                                                                <div className='font-regular font-size5 color-text'>{fairValue}</div>
                                                                            </Col>
                                                                        </Row>
                                                                        <Row className='g-0 justify-content-center align-items-center'>
                                                                            <BzCard className='calculators-innercard'>
                                                                            <Row className='g-0'>
                                                                            <Col xs={12} md={9} className='flex-column justify-content-start align-items-center'>
                                                                                <div className='font-medium font-size6 color-subtext text-uppercase'>{(Object.keys(objScripSearch).length) ?
                                                                                    <>
                                                                                        <div className='d-flex align-items-center'>
                                                                                            <div className='font-medium font-size4 color-text text-uppercase'>{objScripSearch?.sSymbol}</div>
                                                                                            <div className='chips-wrap'>
                                                                                                <div className='font-regular font-size4 color-subtext exchange-chip ms-2'>{objScripSearch.sExchange}</div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div>
                                                                                            <OptionPopOverName />
                                                                                        </div>
                                                                                        <div className='font-regular font-size4 color-subtext'>{objScripSearch.sDerivitiveDesc.split("--")[0]}</div>
                                                                                    </>
                                                                                    : null}
                                                                                </div>
                                                                            </Col>
                                                                            {/* ManasaB : 01/12/2023 : BT-115296 Calculator Bug Fixing - End */}
                                                                            {(Object.keys(objScripSearch).length) ?
                                                                                <Col xs={12} md={3} className='text-xl-end mt-2 mt-md-0'>                                                                                    
                                                                                        <BzButton className='btn btn-positive btn-sm text-capitalize' onClick={() => onBuySellClick('BUY')}>B</BzButton>
                                                                                        <BzButton className='btn btn-negative btn-sm text-capitalize ms-2' onClick={() => onBuySellClick('SELL')}>S</BzButton>                                                                                  
                                                                                    <div className='font-regular font-size4 color-subtext'>{resultSpotPrice > 0 ? resultSpotPrice : ''}</div>
                                                                                </Col> : null}
                                                                        </Row>
                                                                    </BzCard>
                                                                    </Row>
                                                                </>
                                                                }
                                                            </div>                                                        
                                                    </Container>
                                                </Col>
                                            </Row>
                                            <div className='calc-fixed-btns'>
                                                <Row className='g-0 py-xl-3'> 
                                                    <Col xl={4}>
                                                        <Container className='p-0'>
                                                            <Row className='g-0'>
                                                                <Col className='d-flex justify-content-start align-items-center'>
                                                                    <BzButton className='btn btn-md btn-block btn-primary me-3' onClick={handleCalculate}>Calculate</BzButton>
                                                                </Col>
                                                                <Col className='d-flex justify-content-center align-items-center'>
                                                                    <BzButton className='btn btn-md btn-block btn-outline ms-3' onClick={handleReset}>Reset</BzButton>
                                                                </Col>
                                                            </Row>
                                                        </Container>
                                                    </Col>
                                                </Row>
                                            </div>       
                                        </Container>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                    </>
                    : layoutType === LAYOUT_TYPE.VERTICAL ?
                        <>
                            <div className='sticky-calculators-height'>
                                <Container fluid className='mt-3 px-3'>
                                    <Row className='g-0 mb-3 site-calc-search'>
                                        <Col className='d-flex justify-content-start align-items-center calculator-form-control'>
                                            {

                                                bToggleSearchBar ? (
                                                    <div className='w-100'> {/* Bhagyashri P [12-12-2023] : BT-107433 Calculators Integration - class changes */}
                                                        <InlineScripSeach className='site-calc-search' ref={inputRef} handleSelectScripFromGlobalSearch={handleSelectScripFromGlobalSearch} setBToggleSearchBar={setBToggleSearchBar} bFut={true} bSelectedCalculatorScrip={(Object.keys(objScripSearch).length > 0) ? true : false} bIsFutureFair={true} />{/*}ManasaB : 22/11/2023 : BT-115296 Calculator Bug Fixing : Added bIsFutureFair*/}
                                                    </div>
                                                )
                                                    :
                                                    <>
                                                        <div className='font-medium font-size4 color-text text-uppercase me-2'>{objScripSearch?.sSymbol}</div>
                                                        {(Object.keys(objScripSearch).length) ?
                                                            <OptionPopOverName />
                                                            : null
                                                        }
                                                        <div className='icon-16 icon-search icon-dark' onClick={handleSearch}></div>
                                                    </>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className='mb-3'>
                                        <Col className='d-flex flex-wrap justify-content-start align-self-start'>
                                            <div className='font-regular font-size3 color-subtext mb-1'>Spot Price</div>
                                            <div className='input-group'>
                                                <BzInputText onKeyDown={(e) => (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') && e.preventDefault()} size='sm' type="text" name='spotPrice' value={selectCalculatorOption?.spotPrice} className='font-regular form-control' placeholder='Enter Value' onChange={handleCalculatorInputs} />
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className='mb-3'>
                                        <Col md={6} className='d-flex flex-wrap justify-content-start align-self-start'>
                                            <div className='font-regular font-size3 color-subtext mb-1'>Expiry</div>
                                            <div className='Bzmodalselect-dropdown w-100'>
                                                <BzDropdown>
                                                    <Dropdown.Toggle disabled={Object.keys(objScripSearch).length === 0} className='btn-default'>{selectCalculatorOption?.expiryOrContractDays?.expireDate ? selectCalculatorOption?.expiryOrContractDays?.expireDate : 'Enter Value'}</Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        {arrExpiryDayOption?.length > 0 && arrExpiryDayOption?.map((eachOption, i) => (
                                                            <Dropdown.Item key={i} onClick={() => handleOnSelectCalculatorOptionChange({ target: { value: JSON.stringify({ date: eachOption?.expireDate, days: eachOption?.nDayDiff }), name: 'expiryOrContractDays' } })}>{`${eachOption?.expireDate}  `}</Dropdown.Item>
                                                        ))}
                                                        <Dropdown.Item onClick={() => handleOnSelectCalculatorOptionChange({ target: { value: 'customDays', name: 'expiryOrContractDays' } })}>Custom Day's</Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </BzDropdown>
                                            </div>
                                        </Col>                                        
                                        <Col md={6} className='d-flex flex-column justify-content-start align-items-start'>
                                            <div className='font-regular font-size3 color-subtext mb-1'>Contract Days</div>
                                            <div className={`input-group position-relative ${bcustomDays ? 'disabled pointer-events-none' : ''}`}>
                                                <div className='icon-12 icon-order-decrease input-number-left-wrap' name='capPrice' onClick={() => { setCustomDays(customDays - 1); }}></div>
                                                <BzInputText onKeyDown={(e) => (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') && e.preventDefault()} type='number' size="sm" name='customDays' disabled={bcustomDays} value={customDays} className='text-center p-0 font-regular' min={0} onChange={(e) => setCustomDays(e.target.value)} />   {/* Bhagyashri P [07-12-2023] : BT-107433 Calculators Integration - class changes */}
                                                <div className='icon-12 icon-order-increase input-number-right-wrap' name='capPrice' onClick={() => { setCustomDays(customDays + 1); }}></div>   {/* Bhagyashri P [07-12-2023] : BT-107433 Calculators Integration - class changes */}
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className='mb-3'>
                                        <Col md={6} className='d-flex flex-wrap justify-content-start align-self-start'>
                                            <div className='font-regular font-size3 color-subtext mb-1'>Interest rate [%]</div>
                                            <div className='input-group mb-1'>
                                                <BzInputText onKeyDown={(e) => (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') && e.preventDefault()} P size='sm' type="text" name='interestRate' value={selectCalculatorOption?.interestRate} className='font-regular form-control' placeholder='Enter Value' onChange={handleCalculatorInputs} />
                                            </div>
                                            <div className='icon-12 icon-info icon-grey me-1 m-t-2'></div>
                                            <div className='font-regular font-size1 color-subtext'>Range: 0.01-99.99%</div>                                           
                                            {objWarnings?.interestRate ? <span className='font-regular font-size1 color-error ms-1'>Please enter Interest Rate between 0.01 and 99.99</span> : null}
                                        </Col>                                        
                                        <Col md={6} className='d-flex flex-wrap justify-content-start align-self-start'>
                                            <div className='font-regular font-size3 color-subtext mb-1'>Dividend</div>
                                            <div className='input-group mb-1'>
                                                <BzInputText size='sm' type="text" name='dividend' value={selectCalculatorOption?.dividend} className='font-regular form-control' onChange={handleCalculatorInputs} placeholder='Enter Value' />
                                            </div>
                                            <div className='icon-12 icon-info icon-grey me-1 m-t-2'></div>
                                            <div className='font-regular font-size1 color-subtext'>Range: 0.01-99.99%</div>                                            
                                            {objWarnings?.dividend ? <span className='font-regular font-size1 color-error ms-1'>Please enter Dividend between 0 and 99.99</span> : null}
                                        </Col>
                                    </Row>
                                    {fairValue > 0 &&
                                    <>
                                        <Row className='g-0 mt-4'>
                                            <Col className='d-flex justify-content-start align-items-center'>
                                                <div className='font-medium font-size5 color-text me-2'>Fair Value:</div>
                                                <div className='font-regular font-size5 color-text'>{fairValue}</div>
                                            </Col>
                                        </Row>                                                                     
                                        <Row className='g-0'>
                                            <BzCard className='calculators-innercard'>
                                                <Row className='g-0'>
                                                    <Col md={9} className='flex-column justify-content-start align-items-center'>
                                                        <div className='font-medium font-size4 color-subtext text-uppercase me-2'>{(Object.keys(objScripSearch).length) ?
                                                            <>
                                                                <div className='d-flex align-items-center'>
                                                                    <div className='font-medium font-size4 color-text text-uppercase me-2'>{objScripSearch?.sSymbol}</div>
                                                                    <div className='chips-wrap'>
                                                                        <div className='font-regular font-size4 color-subtext exchange-chip'>{objScripSearch.sExchange}</div>
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <OptionPopOverName />
                                                                </div>
                                                                <div className='font-regular font-size4 color-subtext'>{objScripSearch.sDerivitiveDesc.split("--")[0]}</div>
                                                            </>
                                                            : null}
                                                        </div>
                                                    </Col>                                                  
                                                    {(Object.keys(objScripSearch).length) ?
                                                        <Col md={3} className='text-end'>
                                                            <div className='pb-1'>
                                                                <BzButton className='btn btn-positive btn-sm text-capitalize' onClick={() => onBuySellClick('BUY')} >B</BzButton>
                                                                <BzButton className='btn btn-negative btn-sm text-capitalize ms-2' onClick={() => onBuySellClick('SELL')} >S</BzButton>
                                                            </div>
                                                            <div className='font-regular font-size4 color-subtext'>{resultSpotPrice > 0 ? resultSpotPrice : ''}</div>
                                                        </Col>
                                                    : null}
                                                </Row>
                                            </BzCard>
                                        </Row>
                                        </>
                                    }
                                    <div className='sticky-calc-footer'>
                                        <Row className='pt-4 g-0 px-3'>
                                            <Col className='d-flex justify-content-center align-items-center'>
                                                <BzButton className='btn btn-md btn-block btn-outline' onClick={handleReset}>Reset</BzButton>
                                            </Col>
                                            <Col md={1}>&nbsp;</Col>
                                            <Col className='d-flex justify-content-end align-items-center'>
                                                <BzButton className='btn btn-md btn-block btn-primary' onClick={handleCalculate}>Calculate</BzButton>
                                            </Col>
                                        </Row>
                                    </div>
                                </Container>
                            </div>

                        </>
                        : null
            }
        </>
    );
};

export default FutureFairValue; 